import { jsx as _jsx } from "react/jsx-runtime";
import { memo } from 'react';
const SvgIconPause = (props) => (_jsx("svg", { xmlns: "http://www.w3.org/2000/svg", width: 24, height: 24, fill: "currentColor", focusable: false, ...props, children: _jsx("path", { d: "M8 7h3v10H8zm5 0h3v10h-3z" }) }));
const Memo = memo(SvgIconPause);
export default Memo;
//# sourceMappingURL=IconPause.js.map